(function ($) {
    var $carousels = $('body').find('.s-carousel-items');

    if ($carousels.length > 0) {
        $carousels.each(function () {
            var $carousel = $(this);

            $carousel.on('init', function(){
                window.performanceLoad.researchItems();
                window.performanceLoad.runProcessing();
            });

            $carousel.slick({
                infinite: true,
                slidesToScroll: 1,
                slidesToShow: 3,
                centerMode: true,
                centerPadding: '340px',
                arrows: false,
                dots: true,
                adaptiveHeight: true,
                responsive: [
                    {
                        breakpoint: 2401,
                        settings: {
                            slidesToShow: 2
                        }
                    },
                    {
                        breakpoint: 1701,
                        settings: {
                            slidesToShow: 1,
                            centerPadding: '400px'
                        }
                    },
                    {
                        breakpoint: 1501,
                        settings: {
                            slidesToShow: 1,
                            centerPadding: '340px'
                        }
                    },
                    {
                        breakpoint: 1301,
                        settings: {
                            slidesToShow: 1,
                            centerPadding: '200px'
                        }
                    },
                    {
                        breakpoint: 1001,
                        settings: {
                            slidesToShow: 1,
                            centerPadding: '130px'
                        }
                    },
                    {
                        breakpoint: 850,
                        settings: {
                            slidesToShow: 1,
                            centerPadding: '100px'
                        }
                    },
                    {
                        breakpoint: 700,
                        settings: {
                            slidesToShow: 1,
                            centerPadding: '43px'
                        }
                    }
                ]
            });

            $carousel.on('beforeChange', function(){
                window.performanceLoad.researchItems();
                window.performanceLoad.runProcessing();
            }).on('afterChange', function(){
                window.performanceLoad.researchItems();
                window.performanceLoad.runProcessing();
            }).on('breakpoint', function(){
                window.performanceLoad.researchItems();
                window.performanceLoad.runProcessing();
            });
        });
    }

})(jQuery);